export class LogDocument {    
    filename: string;
    moduleName: string;    
  
    constructor(filename,moduleName){
this.moduleName=moduleName;
this.filename=filename;
    }
   }


// WEBPACK FOOTER //
// ./src/app/modules/home/entity/logDocument.ts